import React from 'react';
import PropTypes from 'prop-types';

const TextArea = ({
  placeholder = '',
  value = '',
  onChange,
  rows = 4,
  disabled = false,
  fullWidth = true,
  className = '',
  ...props
}) => {
  const baseClasses = 'tw-border tw-border-[#e1e3ea] tw-rounded-lg tw-bg-white-1 tw-text-muted tw-font-inter tw-transition-colors tw-duration-200 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-blue-500 tw-resize-vertical';

  const textareaClasses = `
    ${baseClasses}
    ${fullWidth ? 'tw-w-full' : ''}
    ${disabled ? 'tw-opacity-50 tw-cursor-not-allowed tw-bg-gray-100' : ''}
    tw-px-3 tw-py-2 tw-text-sm sm:tw-px-4 sm:tw-py-3 sm:tw-text-base
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <textarea
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      rows={rows}
      disabled={disabled}
      className={textareaClasses}
      {...props}
    />
  );
};

TextArea.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
};

export default TextArea;
